import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import { Container } from "reactstrap"

import logo from "assets/images/siddhi_full_hd.png"
import Configs from "../../config"
import secureLocalStorage from "react-secure-storage"
import { FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/loader"
import { IoMdEye, IoMdEyeOff } from "react-icons/io"
import { MdEmail, MdPhone } from "react-icons/md"
import { FiLock } from "react-icons/fi"

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .kep-login-root {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0a0a0f;
    font-family: 'DM Sans', sans-serif;
    position: relative;
    overflow: hidden;
  }

  .kep-login-root::before {
    content: '';
    position: absolute;
    width: 600px; height: 600px;
    background: radial-gradient(circle, rgba(0,120,255,0.18) 0%, transparent 70%);
    top: -150px; left: -150px;
    border-radius: 50%;
    pointer-events: none;
  }

  .kep-login-root::after {
    content: '';
    position: absolute;
    width: 500px; height: 500px;
    background: radial-gradient(circle, rgba(0,200,180,0.12) 0%, transparent 70%);
    bottom: -100px; right: -100px;
    border-radius: 50%;
    pointer-events: none;
  }

  .kep-grid-overlay {
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
    background-size: 60px 60px;
    pointer-events: none;
  }

  .kep-card {
    position: relative;
    z-index: 10;
    background: rgba(15, 15, 25, 0.85);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 24px;
    padding: 48px 44px;
    width: 100%;
    max-width: 460px;
    backdrop-filter: blur(20px);
    box-shadow: 0 32px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04) inset;
    animation: cardIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  @keyframes cardIn {
    from { opacity: 0; transform: translateY(28px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }

  .kep-logo-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 32px;
  }

  .kep-logo-wrap img {
    height: 52px;
    object-fit: contain;
    filter: brightness(1.1);
  }

  .kep-heading {
    font-family: 'Syne', sans-serif;
    font-size: 26px;
    font-weight: 800;
    color: #ffffff;
    letter-spacing: -0.5px;
    margin-bottom: 4px;
    text-align: center;
  }

  .kep-sub {
    text-align: center;
    color: rgba(255,255,255,0.4);
    font-size: 14px;
    font-weight: 300;
    margin-bottom: 32px;
  }

  /* Tab Switcher */
  .kep-tabs {
    display: flex;
    background: rgba(255,255,255,0.05);
    border-radius: 12px;
    padding: 4px;
    margin-bottom: 28px;
    gap: 4px;
  }

  .kep-tab-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px 0;
    border-radius: 9px;
    border: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    transition: all 0.25s ease;
    background: transparent;
    color: rgba(255,255,255,0.4);
  }

  .kep-tab-btn.active {
    background: rgba(255,255,255,0.1);
    color: #fff;
    box-shadow: 0 2px 12px rgba(0,0,0,0.3);
  }

  .kep-tab-btn svg { opacity: 0.7; }
  .kep-tab-btn.active svg { opacity: 1; }

  /* Field */
  .kep-field {
    margin-bottom: 20px;
    animation: fieldIn 0.3s ease both;
  }

  @keyframes fieldIn {
    from { opacity: 0; transform: translateX(-8px); }
    to   { opacity: 1; transform: translateX(0); }
  }

  .kep-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: rgba(255,255,255,0.5);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin-bottom: 8px;
  }

  .kep-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }

  .kep-input-icon {
    position: absolute;
    left: 14px;
    color: rgba(255,255,255,0.3);
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .kep-input {
    width: 100%;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 14.5px;
    padding: 13px 14px 13px 42px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  }

  .kep-input::placeholder { color: rgba(255,255,255,0.2); }

  .kep-input:focus {
    border-color: rgba(0,140,255,0.6);
    background: rgba(255,255,255,0.07);
    box-shadow: 0 0 0 3px rgba(0,140,255,0.1);
  }

  .kep-input.has-right { padding-right: 44px; }

  .kep-eye-btn {
    position: absolute;
    right: 13px;
    background: none;
    border: none;
    cursor: pointer;
    color: rgba(255,255,255,0.35);
    display: flex;
    align-items: center;
    padding: 0;
    transition: color 0.2s;
  }
  .kep-eye-btn:hover { color: rgba(255,255,255,0.7); }

  /* Phone prefix */
  .kep-phone-prefix {
    position: absolute;
    left: 42px;
    color: rgba(255,255,255,0.5);
    font-size: 14.5px;
    font-family: 'DM Sans', sans-serif;
    pointer-events: none;
    letter-spacing: 0.3px;
  }

  .kep-input.phone-input { padding-left: 80px; }

  /* Error */
  .kep-error {
    font-size: 12px;
    color: #ff6b6b;
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  /* Submit */
  .kep-submit {
    width: 100%;
    padding: 14px;
    border-radius: 12px;
    border: none;
background: linear-gradient(
  135deg,
  #fff6b0 0%,
  #ffd700 25%,
  #ffb800 50%,
  #c99700 75%,
  #fff1a8 100%
);    color: #000000;
    font-family: 'Syne', sans-serif;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.4px;
    cursor: pointer;
    margin-top: 8px;
    transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
    box-shadow: 0 8px 32px rgba(255, 215, 0, 0.28);
    position: relative;
    overflow: hidden;
  }

  .kep-submit::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.12), transparent);
  }

  .kep-submit:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 8px 32px rgba(255, 215, 0, 0.48);
  }

  .kep-submit:active { transform: translateY(0); opacity: 1; }

  .kep-submit:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

  .kep-footer {
    text-align: center;
    margin-top: 24px;
    font-size: 12.5px;
    color: rgba(255,255,255,0.25);
    letter-spacing: 0.2px;
  }

  .kep-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 24px 0;
  }
  .kep-divider-line {
    flex: 1;
    height: 1px;
    background: rgba(255,255,255,0.08);
  }
  .kep-divider-text {
    font-size: 11px;
    color: rgba(255,255,255,0.2);
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`

const Login = () => {
  const navigate = useNavigate()
  document.title = "Login | Siddhi Tax Consultant"

  const [loading, setLoading] = useState(false)
  const [loginMode, setLoginMode] = useState("email") // "email" | "phone"
  const [showPassword, setShowPassword] = useState(false)
  const [errors, setErrors] = useState({})

  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    password: "",
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }))
  }

  const handleModeSwitch = mode => {
    setLoginMode(mode)
    setErrors({})
  }

  const validate = () => {
    const errs = {}

    if (loginMode === "email") {
      if (!formData.email) {
        errs.email = "Email is required"
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        errs.email = "Enter a valid email address"
      }
    } else {
      if (!formData.phone) {
        errs.phone = "Phone number is required"
      } else if (!/^\d{10}$/.test(formData.phone)) {
        errs.phone = "Enter a valid 10-digit phone number"
      }
    }

    if (!formData.password) {
      errs.password = "Password is required"
    } else if (formData.password.length < 6) {
      errs.password = "Password must be at least 6 characters"
    }

    return errs
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const validationErrors = validate()
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }

    const payload =
      loginMode === "email"
        ? { email: formData.email, password: formData.password }
        : { phone: formData.phone, password: formData.password }

    // original api call
    const APIData = await FetchPostData(setLoading, "auth/login", payload)

    // Fake API call
    // const APIData = await fakeLogin(setLoading, payload)

    if (APIData?.data?.success) {
      Swal.fire({
        title: "Login Successful",
        text: APIData?.data?.message,
        icon: "success",
        timer: 1000,
      })
      secureLocalStorage?.setItem("admin_user", APIData?.data?.data)
      secureLocalStorage?.setItem("auth_token", APIData?.data?.token)
      navigate(`${Configs.appurl}dashboard`)
    } else {
      Swal.fire({
        title: "Login Unsuccessful",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <React.Fragment>
      <style>{styles}</style>
      {loading && <Loader />}

      <div className="kep-login-root">
        <div className="kep-grid-overlay" />

        <div className="kep-card">
          {/* Logo */}
          <div className="kep-logo-wrap">
            <Link to={`${Configs.appurl}`}>
              <img src={logo} alt="STC Logo" className="bg-white" />
            </Link>
          </div>

          <p className="kep-sub">
            Sign in to your Siddhi Tax Consultant account
          </p>

          {/* Tab Switcher */}
          <div className="kep-tabs">
            <button
              type="button"
              className={`kep-tab-btn${loginMode === "email" ? " active" : ""}`}
              onClick={() => handleModeSwitch("email")}
            >
              <MdEmail size={16} /> Email
            </button>
            <button
              type="button"
              className={`kep-tab-btn${loginMode === "phone" ? " active" : ""}`}
              onClick={() => handleModeSwitch("phone")}
            >
              <MdPhone size={16} /> Phone Number
            </button>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            {/* Email Field */}
            {loginMode === "email" && (
              <div className="kep-field" key="email-field">
                <label className="kep-label">
                  Email Address <span style={{ color: "#ff6b6b" }}>*</span>
                </label>
                <div className="kep-input-wrap">
                  <span className="kep-input-icon">
                    <MdEmail size={17} />
                  </span>
                  <input
                    className="kep-input"
                    type="email"
                    name="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    autoComplete="email"
                  />
                </div>
                {errors.email && <p className="kep-error">⚠ {errors.email}</p>}
              </div>
            )}

            {/* Phone Field */}
            {loginMode === "phone" && (
              <div className="kep-field" key="phone-field">
                <label className="kep-label">
                  Phone Number <span style={{ color: "#ff6b6b" }}>*</span>
                </label>
                <div className="kep-input-wrap">
                  <span className="kep-input-icon">
                    <MdPhone size={17} />
                  </span>
                  <span className="kep-phone-prefix">+91</span>
                  <input
                    className="kep-input phone-input"
                    type="tel"
                    name="phone"
                    placeholder="9876543210"
                    value={formData.phone}
                    onChange={handleChange}
                    maxLength={10}
                    autoComplete="tel"
                  />
                </div>
                {errors.phone && <p className="kep-error">⚠ {errors.phone}</p>}
              </div>
            )}

            {/* Password Field */}
            <div className="kep-field">
              <label className="kep-label">
                Password <span style={{ color: "#ff6b6b" }}>*</span>
              </label>
              <div className="kep-input-wrap">
                <span className="kep-input-icon">
                  <FiLock size={16} />
                </span>
                <input
                  className="kep-input has-right"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="kep-eye-btn"
                  onClick={() => setShowPassword(prev => !prev)}
                  tabIndex={-1}
                >
                  {showPassword ? (
                    <IoMdEye size={18} />
                  ) : (
                    <IoMdEyeOff size={18} />
                  )}
                </button>
              </div>
              {errors.password && (
                <p className="kep-error">⚠ {errors.password}</p>
              )}
            </div>

            <button type="submit" className="kep-submit" disabled={loading}>
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>

          <p className="kep-footer">
            © {new Date().getFullYear()} Siddhi Tax Consultant
          </p>
        </div>
      </div>
    </React.Fragment>
  )
}

Login.propTypes = {
  history: PropTypes.object,
}

export default Login
